/**
 * GlobalLoaderZone — partage l'état du loader général avec sa zone.
 *
 * @remarks
 * À monter autour du conteneur `relative` qui porte `ActiveGlobalLoader` et la
 * vue centrale. Une seule instance de `useGlobalLoaderVisible` pilote à la fois
 * le voile et les loaders locaux de la zone (qui se masquent, cf.
 * `shared/ui/loader-veil-context`).
 */

import type { ReactNode } from 'react';
import { LoaderVeilContext } from '@/shared/ui/loader-veil-context';
import { useGlobalLoaderVisible } from './use-global-loader-visible';

export function GlobalLoaderZone({ children }: { children: ReactNode }) {
  const visible = useGlobalLoaderVisible();
  return <LoaderVeilContext.Provider value={visible}>{children}</LoaderVeilContext.Provider>;
}
